import { Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';

let BsEnMeasurementsExtraSieveSection: React.FC<IWorksheetComponent> = () => {
  return (
    <SectionGroup heading={'Material Retained on Extra Sieve'}>
      <ListFieldSection>
        <Field input={<TextOutput />} name="ExtraSieve.Code" />
        <Field input={<NumericInput />} name="ContainerMass_ExtraSieve" />
        <Field input={<NumericInput />} name="ContainerAndRetainedMass_ExtraSieve" />
        <Field input={<TextOutput />} name="RetainedMass_ExtraSieve" />
      </ListFieldSection>
    </SectionGroup>
  );
};

BsEnMeasurementsExtraSieveSection = withInjectedProps(BsEnMeasurementsExtraSieveSection);

export { BsEnMeasurementsExtraSieveSection };
export default BsEnMeasurementsExtraSieveSection;
